import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BlogList from '../components/BlogList';
import { PERSON_SCHEMA, SITE_URL } from '../data/person';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Bjarne Christiansen',
  url: SITE_URL,
  description:
    'Founder and technologist writing about startup fundamentals, fundraising, and building from the Nordic edge.',
  author: { '@type': 'Person', name: 'Bjarne Christiansen' },
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/?search={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const personSchema = { '@context': 'https://schema.org', ...PERSON_SCHEMA };

const Home = () => (
  <div className="home-page">
    <Helmet>
      <meta property="og:title" content="Bjarne Christiansen" />
      <meta property="og:description" content="Writing on startup fundamentals, fundraising, and the Nordic ecosystem." />
      <meta property="og:url" content={SITE_URL} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${SITE_URL}/og/default.png`} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Bjarne Christiansen" />
      <meta name="twitter:description" content="Writing on startup fundamentals, fundraising, and the Nordic ecosystem." />
      <meta name="twitter:image" content={`${SITE_URL}/og/default.png`} />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
    </Helmet>
    <section className="home-intro">
      <h1 className="home-title">Bjarne Christiansen</h1>
      <p className="home-tagline">
        Founder and technologist. I write about building companies from the inside — startup
        fundamentals that hold up under pressure, what fundraising looks like from both sides of the
        table, and what the Nordic ecosystem gets right that Silicon Valley misses.
      </p>
      <p className="home-context">
        Co-founded{' '}
        <a href="https://realm.io" target="_blank" rel="noopener noreferrer">
          Realm
        </a>{' '}
        (YC S11) — a mobile database that reached 2 billion device installs before its acquisition
        by MongoDB in 2019. Previously spent over a decade at Nokia building software for hundreds
        of millions of devices.
        . <Link to="/now">What I'm focused on now →</Link>
      </p>
      <div className="home-credentials" aria-label="Key credentials">
        <span className="home-credential">
          <a href="https://realm.io" target="_blank" rel="noopener noreferrer">
            Realm
          </a>{' '}
          → MongoDB acquisition
        </span>
        <span className="home-credential-sep" aria-hidden="true">·</span>
        <span className="home-credential">Y Combinator S11</span>
        <span className="home-credential-sep" aria-hidden="true">·</span>
        <span className="home-credential">$40M raised</span>
      </div>
    </section>

    <section className="home-writing">
      <h2>Writing</h2>
      <BlogList />
    </section>
  </div>
);

export default Home;
